import script from "./ModalExito.vue?vue&type=script&setup=true&lang=js"
export * from "./ModalExito.vue?vue&type=script&setup=true&lang=js"

import "./ModalExito.vue?vue&type=style&index=0&id=ace9362a&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-ace9362a"]])

export default __exports__